import React, { useState, useEffect, Suspense } from "react";
import '../../css/PropertyList.css';
import { Link } from 'react-router-dom';
import builderlogo from '../../images/builder-logo.png';
import adimg1 from '../../images/adimg1.jpg';
import adimg from '../../images/adimg.png';
import top3 from '../../images/top3.png';
import axios from "axios";
import { useLocation } from "react-router-dom";
import LoadingSkeleton from "../common/LoadingSkeleton";

const PropertyList = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };


  const [list, setList] = useState([]);
  const location = useLocation();
  const fullPath = location.pathname;

 


  const fetchSidebarData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${fullPath}`
      );

      if (response.status) {
        // Handle the response data here
        setList(response.data.data);
      }

    } catch (error) {

      setList([]);
    }
  };


  useEffect(() => {

    fetchSidebarData();

  }, []);



  return (
    <div className='body'>

      <div className='row property-list'>


        <div className='col-md-3 left'>
          <div className='property-filter'>

            <div className='resert-button m-4'>
              <button className='btn'>Resert Filter</button>
            </div>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.00005 16.0001V10.0002H2L9.50005 3L17 9.99999H15V16H11V11.5001H8.00006V16L4.00005 16.0001Z" stroke="black" stroke-width="1.5" stroke-miterlimit="5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Property Type
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.7648 8.38038L12.2998 6.78538V2.21538C12.2982 2.1195 12.2691 2.0261 12.2159 1.94632C12.1627 1.86653 12.0877 1.80372 11.9998 1.76538L8.24981 0.0403785C8.18399 0.00991802 8.11233 -0.00585938 8.03981 -0.00585938C7.96728 -0.00585938 7.89562 0.00991802 7.82981 0.0403785L4.07981 1.76538C3.99302 1.80554 3.91957 1.86976 3.86816 1.9504C3.81676 2.03105 3.78957 2.12475 3.78981 2.22038V6.79038L0.339806 8.38038C0.253016 8.42054 0.179566 8.48476 0.128165 8.5654C0.0767641 8.64605 0.0495696 8.73975 0.0498062 8.83538V13.7254C0.0495696 13.821 0.0767641 13.9147 0.128165 13.9954C0.179566 14.076 0.253016 14.1402 0.339806 14.1804L4.08981 15.9054C4.15562 15.9358 4.22728 15.9516 4.29981 15.9516C4.37233 15.9516 4.44399 15.9358 4.50981 15.9054L8.04981 14.2754L11.5898 15.9054C11.6556 15.9358 11.7273 15.9516 11.7998 15.9516C11.8723 15.9516 11.944 15.9358 12.0098 15.9054L15.7598 14.1804C15.8466 14.1402 15.92 14.076 15.9714 13.9954C16.0228 13.9147 16.05 13.821 16.0498 13.7254V8.83538C16.0505 8.74029 16.024 8.64697 15.9736 8.56638C15.9231 8.48579 15.8507 8.42127 15.7648 8.38038ZM14.3598 8.83538L11.8048 10.0004L9.24981 8.83538L11.8048 7.66038L14.3598 8.83538ZM8.04981 1.04038L10.6048 2.21538L8.04981 3.39038L5.49981 2.21538L8.04981 1.04038ZM4.29981 7.65538L6.85481 8.83038L4.29981 10.0004L1.74481 8.83538L4.29981 7.65538ZM7.54981 13.4004L4.29981 14.9004L1.04981 13.4004V9.61538L4.08981 11.0004C4.15427 11.0294 4.22413 11.0443 4.29481 11.0443C4.36548 11.0443 4.43535 11.0294 4.49981 11.0004L7.53981 9.60038L7.54981 13.4004ZM4.79981 6.78538V3.00038L7.83981 4.40038C7.90562 4.43084 7.97728 4.44662 8.04981 4.44662C8.12233 4.44662 8.19399 4.43084 8.25981 4.40038L11.2998 3.00038V6.79038L8.04981 8.29038L4.79981 6.78538ZM15.0548 13.4054L11.8048 14.9054L8.54981 13.4054V9.61038L11.5948 11.0004C11.6586 11.0286 11.7276 11.0432 11.7973 11.0432C11.8671 11.0432 11.936 11.0286 11.9998 11.0004L15.0398 9.60038L15.0548 13.4054Z" fill="black" />
                    </svg>
                    BHK Type
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="9.5" cy="10.5" r="7.25" stroke="black" stroke-width="1.5" />
                      <path d="M7.4209 7H8.46544C9.49346 7 10.6247 7.33442 10.6247 8.89916C10.6247 10.596 9.18794 11.2442 7.66036 11.0708C7.64232 11.0687 7.62407 11.0723 7.60819 11.0811C7.59231 11.0899 7.57959 11.1035 7.57184 11.1199C7.56409 11.1363 7.56168 11.1548 7.56497 11.1726C7.56826 11.1905 7.57708 11.2069 7.59017 11.2194L10.8353 14.7205" stroke="black" stroke-linecap="round" />
                      <path d="M11.8673 7H8.23828" stroke="black" stroke-linecap="round" />
                      <path d="M7.47021 8.95312H11.892" stroke="black" stroke-linecap="round" />
                    </svg>

                    Price Range
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.82621 17.8464C3.79327 17.7947 3.77731 17.7341 3.78054 17.6729C3.78376 17.6118 3.80603 17.5532 3.84421 17.5053C4.21754 17.0008 4.74026 16.6266 5.33821 16.4359C5.94292 16.2815 6.56926 16.2296 7.19113 16.2825C7.2308 16.2881 7.2697 16.2981 7.30705 16.3126C7.39471 16.3385 7.49353 16.4445 7.56841 16.3234C7.61224 16.2347 7.63503 16.1372 7.63501 16.0383C7.64536 15.9467 7.62307 15.8544 7.57207 15.7776C7.52107 15.7008 7.44463 15.6445 7.35619 15.6185C6.96522 15.4537 6.53438 15.4077 6.11743 15.4862C5.80103 15.5414 5.4922 15.6336 5.19727 15.7607C5.09138 15.821 4.96607 15.8374 4.84825 15.8063C4.77625 15.7863 4.71199 15.6813 4.74871 15.6214C4.77625 15.5686 4.80881 15.5186 4.84591 15.472C5.01191 15.2951 5.22052 15.1638 5.45179 15.0906C6.11059 14.8724 6.77749 14.7578 7.45447 15.0137C7.67551 15.0978 7.72212 15.0215 7.72716 14.8575C7.74156 14.3954 7.76317 13.9335 7.76119 13.4715C7.75723 12.3868 7.74157 11.3016 7.73023 10.2164C7.72915 10.1161 7.72789 10.0155 7.72105 9.9154C7.72084 9.87519 7.70586 9.83645 7.67893 9.80658C7.65201 9.7767 7.61505 9.75777 7.57507 9.7534C7.51557 9.74392 7.45525 9.7406 7.39507 9.7435C6.71359 9.7759 6.03193 9.81658 5.34991 9.84106C4.80739 9.86122 4.26468 9.85708 3.72216 9.87274C3.22086 9.8875 2.71939 9.91054 2.21863 9.9379C2.13977 9.95459 2.05752 9.94119 1.98804 9.90032C1.91856 9.85945 1.86688 9.79408 1.84315 9.71704C1.83127 9.65866 1.80277 9.60497 1.76107 9.56242C1.43059 9.343 1.41655 8.98156 1.37569 8.6527C1.31071 8.13556 1.28155 7.61284 1.26211 7.09156C1.22377 6.0886 1.22179 5.08528 1.14259 4.08214C1.06663 3.1222 0.988869 2.16244 0.896349 1.20412C0.873309 0.964179 0.855125 0.72334 0.846845 0.48268C0.844505 0.401719 0.867049 0.321987 0.911434 0.254236C0.955818 0.186484 1.01991 0.13397 1.09507 0.103778C1.3144 -0.0041144 1.56517 -0.0296636 1.80174 0.0317789C2.15822 0.0895882 2.51882 0.118362 2.87995 0.117818C3.18001 0.137438 3.47863 0.1819 3.77833 0.20026C4.19935 0.22528 4.62162 0.250479 5.04264 0.251019C6.10788 0.251019 7.17349 0.255698 8.23819 0.225998C9.03991 0.203318 9.84018 0.129519 10.6419 0.0787592C10.9216 0.0607592 11.2017 0.03826 11.4821 0.02728C12.2652 -0.00468093 13.0491 0.0640413 13.8146 0.23176C14.047 0.293584 14.2907 0.299749 14.5259 0.249759C14.7034 0.217544 14.8847 0.213353 15.0634 0.237339C15.1576 0.244539 15.2917 0.27856 15.3313 0.34534C15.4695 0.58204 15.7248 0.60742 15.9253 0.7291C15.9908 0.771216 16.0383 0.83622 16.0585 0.91144C16.0623 0.931372 16.0619 0.951893 16.0573 0.971662C16.0527 0.991431 16.0439 1.01 16.0316 1.02615C16.0193 1.0423 16.0037 1.05566 15.9859 1.06536C15.9681 1.07506 15.9484 1.08088 15.9282 1.08244C15.7292 1.09936 15.7858 1.21006 15.8201 1.32814C15.834 1.38612 15.8312 1.44683 15.812 1.50328C15.7977 1.55164 15.7684 1.59418 15.7282 1.62473C15.6881 1.65528 15.6393 1.67226 15.5888 1.6732C15.5283 1.67465 15.4693 1.65357 15.4234 1.61403C15.3774 1.57449 15.3478 1.51931 15.3403 1.45918C15.3443 1.38071 15.3585 1.30309 15.3824 1.22824C15.407 1.12024 15.3799 1.08082 15.2872 1.1098C15.0929 1.15184 14.9048 1.21837 14.7274 1.3078C14.519 1.43165 14.2717 1.47252 14.0345 1.42228C13.9756 1.41004 13.9174 1.39472 13.8601 1.37638C13.2543 1.23247 12.6331 1.16385 12.0104 1.17208C10.9254 1.17766 9.83983 1.17388 8.75497 1.17388V1.20664C7.66975 1.20664 6.58434 1.22464 5.49966 1.20088C4.79766 1.18558 4.09567 1.13266 3.39763 1.05688C2.88139 1.00054 2.37162 0.87976 1.85844 0.78688C1.79958 0.77626 1.74145 0.757719 1.68259 0.748719C1.56001 0.728919 1.48711 0.802718 1.51339 0.920798C1.59763 1.2925 1.69879 1.66096 1.76539 2.03572C1.84531 2.48914 1.91353 2.94652 1.95727 3.40498C2.03563 4.22338 2.10163 5.0431 2.15527 5.86414C2.18677 6.36508 2.18136 6.86836 2.1936 7.37056C2.18489 7.75238 2.21608 8.13407 2.28667 8.50942C2.34517 8.75728 2.27335 9.03142 2.42869 9.26128C2.66863 9.2629 2.90947 9.27532 3.14869 9.26398C3.81037 9.23248 4.47205 9.2026 5.13229 9.14968C5.79253 9.09676 6.44755 9.00568 7.10635 8.95168C7.82635 8.8921 8.54797 8.83522 9.26977 8.81326C10.7553 8.76826 12.2414 8.74504 13.7275 8.71696C14.1491 8.69615 14.5717 8.71422 14.99 8.77096C15.1293 8.78879 15.2701 8.79325 15.4103 8.78428C15.4303 8.78404 15.4501 8.77976 15.4685 8.7717C15.4869 8.76363 15.5034 8.75195 15.5172 8.73736C15.531 8.72276 15.5416 8.70554 15.5486 8.68673C15.5556 8.66792 15.5587 8.6479 15.5577 8.62786C15.564 8.54776 15.5636 8.46748 15.5683 8.3872C15.6198 7.46524 15.6607 6.54274 15.7282 5.62168C15.7739 5.00212 15.8587 4.38526 15.9235 3.76678C15.9384 3.6271 15.9436 3.48634 15.9508 3.34594C15.9672 3.03274 15.9669 3.03274 15.6342 2.85202C15.5799 2.82558 15.5352 2.78296 15.5062 2.73002C15.4772 2.67708 15.4653 2.61643 15.4722 2.55646C15.4812 2.4863 15.5147 2.42158 15.5668 2.37377C15.6189 2.32596 15.6863 2.29815 15.757 2.29528C15.8171 2.29461 15.8767 2.30688 15.9317 2.33128C15.9442 2.33875 15.9583 2.34285 15.9728 2.34317C15.9873 2.34348 16.0016 2.34 16.0144 2.33307C16.0271 2.32614 16.0378 2.316 16.0454 2.30365C16.053 2.29131 16.0573 2.27719 16.0577 2.2627C16.1045 2.00638 16.135 1.74682 16.1837 1.49122C16.2485 1.15732 16.3256 0.82522 16.3985 0.49402C16.4165 0.415261 16.4542 0.34234 16.508 0.282042C16.5618 0.221744 16.6299 0.176027 16.7061 0.14914C16.7433 0.133659 16.7831 0.125762 16.8234 0.125915C16.8636 0.126069 16.9034 0.134268 16.9405 0.150033C16.9775 0.165798 17.011 0.188811 17.039 0.217714C17.067 0.246618 17.089 0.280829 17.1035 0.318338C17.1339 0.392114 17.1503 0.470935 17.1516 0.550718C17.1369 0.931418 17.1142 1.3123 17.0899 1.693C17.0825 1.81288 17.0584 1.93186 17.0506 2.05174C16.9966 2.9134 16.9563 3.77596 16.891 4.63654C16.8417 5.27608 16.7567 5.91292 16.6967 6.55156C16.6386 7.1713 16.5808 7.79068 16.5441 8.41132C16.5241 8.74108 16.5054 9.05626 16.1976 9.262C16.047 9.62578 15.753 9.65188 15.4056 9.64756C13.7375 9.62758 12.0695 9.62956 10.4016 9.62416C10.3613 9.62416 10.3211 9.62416 10.2808 9.6274C10.1188 9.63676 10.0573 9.69526 10.0557 9.84178C10.0526 9.92213 10.0551 10.0026 10.063 10.0826C10.1793 10.9623 10.1442 11.8466 10.1565 12.7306C10.1671 13.5744 10.162 14.4186 10.1645 15.2625C10.1645 15.4234 10.166 15.5841 10.1717 15.7447C10.1764 15.863 10.2308 15.922 10.3672 15.9103C10.4866 15.8902 10.6091 15.9008 10.7233 15.9411C10.8374 15.9814 10.9394 16.0501 11.0197 16.1407C11.0581 16.1865 11.1092 16.2199 11.1665 16.2367C11.2239 16.2535 11.2849 16.2529 11.3419 16.235C11.7931 16.1318 12.2617 16.1303 12.7135 16.2307C12.8101 16.2456 12.909 16.2332 12.9988 16.1947C13.2439 16.1066 13.495 16.0362 13.7501 15.9839C14.0489 15.9378 14.3544 15.9644 14.6406 16.0617C14.753 16.1031 14.851 16.1763 14.9227 16.2723C14.9501 16.3142 14.9674 16.362 14.9733 16.4117C14.9793 16.4615 14.9736 16.5119 14.9569 16.5591C14.9402 16.6064 14.9128 16.6491 14.8768 16.684C14.8409 16.7189 14.7974 16.7451 14.7497 16.7604C14.6912 16.7744 14.6313 16.7816 14.5711 16.7819C14.4908 16.7821 14.4105 16.777 14.3308 16.7667C14.0116 16.7112 13.6831 16.7486 13.3846 16.8746C13.0861 17.0006 12.83 17.2098 12.6471 17.4772C12.5211 17.6471 12.4851 17.6432 12.3051 17.5089C12.1451 17.389 11.9935 17.2569 11.8425 17.126C11.5759 16.875 11.2219 16.7379 10.8558 16.7441C10.6758 16.7491 10.4939 16.7491 10.3136 16.7441C9.99079 16.7226 9.66814 16.7881 9.37921 16.9336C9.295 16.988 9.19516 17.013 9.09525 17.0048C8.99534 16.9966 8.90095 16.9555 8.82679 16.8881C8.77803 16.8526 8.72698 16.8203 8.67397 16.7916C8.63098 16.7652 8.58057 16.7534 8.53034 16.7582C8.48011 16.7629 8.43279 16.7839 8.39551 16.8179C8.30047 16.8918 8.20543 16.966 8.11327 17.0438C8.0759 17.0775 8.02811 17.0974 7.97785 17.1002C7.92759 17.1031 7.87788 17.0886 7.83697 17.0592C7.82109 17.0468 7.80252 17.0382 7.78274 17.0342C7.76297 17.0301 7.74252 17.0308 7.72302 17.036C7.70353 17.0412 7.68552 17.0509 7.67043 17.0643C7.65534 17.0778 7.64358 17.0945 7.63609 17.1132C7.59124 17.2042 7.51834 17.2784 7.42815 17.3248C7.33796 17.3712 7.23524 17.3874 7.13514 17.371C6.91446 17.3667 6.69379 17.3507 6.47293 17.342C5.78634 17.31 5.10548 17.4806 4.51507 17.8325C4.41254 17.8947 4.30399 17.9464 4.19107 17.9868C4.16298 17.9964 4.13346 18.0012 4.10376 18.001C4.04831 18.0003 3.9939 17.9857 3.94545 17.9588C3.897 17.9318 3.85602 17.8931 3.82621 17.8464ZM8.8761 13.2337C8.84211 13.2546 8.81022 13.2787 8.78089 13.3057C8.7664 13.3188 8.75515 13.3351 8.74804 13.3532C8.74092 13.3714 8.73813 13.391 8.73987 13.4105C8.74162 13.4299 8.74786 13.4487 8.7581 13.4653C8.76834 13.4819 8.78231 13.4959 8.79889 13.5062C8.87269 13.5359 8.95567 13.5444 9.02604 13.5797C9.06317 13.595 9.09633 13.6185 9.12301 13.6486C9.14969 13.6786 9.16918 13.7143 9.18002 13.753C9.19086 13.7916 9.19276 13.8323 9.18558 13.8718C9.17839 13.9113 9.1623 13.9487 9.13855 13.9811C9.10802 14.0328 9.06803 14.0784 9.02065 14.1153C8.93628 14.1685 8.87023 14.2463 8.83139 14.3381C8.79255 14.4299 8.78277 14.5315 8.80339 14.6291C8.82445 14.9054 8.77369 15.1835 9.04945 15.3885C9.07631 15.4119 9.09807 15.4406 9.11336 15.4728C9.12866 15.505 9.13717 15.54 9.13835 15.5756C9.13953 15.6113 9.13337 15.6468 9.12024 15.6799C9.10712 15.713 9.0873 15.7431 9.06205 15.7683C9.03667 15.7994 9.00084 15.8306 8.99472 15.866C8.9859 15.9164 8.97997 15.9893 9.00805 16.0199C9.07375 16.0899 9.16087 16.1616 9.26401 16.1205C9.28687 16.103 9.30552 16.0806 9.31857 16.0549C9.33162 16.0293 9.33875 16.001 9.33943 15.9722C9.36445 15.3332 9.38245 14.6942 9.40081 14.1146V13.8144C9.4074 13.7146 9.40685 13.6144 9.39919 13.5147C9.37597 13.3498 9.4998 13.1208 9.28812 13.0359C9.26809 13.0276 9.24664 13.0232 9.22495 13.0231C9.09823 13.0224 8.99472 13.1721 8.8761 13.2337ZM9.22963 11.7881C9.05251 11.8662 8.87305 11.9415 8.70259 12.032C8.67091 12.0486 8.66388 12.1325 8.66658 12.1834C8.6682 12.2054 8.72958 12.2455 8.75658 12.2403C8.92758 12.207 9.09715 12.1658 9.26545 12.1218C9.37705 12.0925 9.42889 11.9859 9.40386 11.8382C9.39828 11.8081 9.36336 11.7833 9.34158 11.7559C9.30359 11.7642 9.2662 11.7749 9.22963 11.7881ZM9.21289 10.2752C9.26032 10.3119 9.2942 10.3633 9.3092 10.4213C9.32419 10.4794 9.31944 10.5408 9.29569 10.5958C9.2062 10.7252 9.10267 10.8443 8.98699 10.9509C8.87546 11.0328 8.75954 11.1085 8.63977 11.1777C8.62177 11.1898 8.63041 11.2436 8.63581 11.2767C8.63815 11.2917 8.66767 11.3163 8.67793 11.3127C8.77243 11.2836 8.86351 11.2407 8.95945 11.219C9.09175 11.1896 9.25717 11.2161 9.35545 11.1453C9.49729 11.0424 9.40585 10.8489 9.42277 10.6953C9.42785 10.6158 9.42839 10.5359 9.42439 10.4563H9.42277C9.42277 10.2572 9.42691 10.058 9.42115 9.85888C9.41773 9.7129 9.34753 9.64504 9.19615 9.64666C8.97781 9.64918 8.75875 9.6589 8.54077 9.6733C8.50045 9.67731 8.46333 9.69707 8.43749 9.72827C8.41164 9.75948 8.39915 9.79961 8.40271 9.83998C8.40588 9.91971 8.41893 9.99873 8.44158 10.0752C8.47164 10.2059 8.51845 10.2486 8.64805 10.2056C8.7253 10.1783 8.80644 10.1637 8.88835 10.1622C9.00621 10.162 9.12063 10.2019 9.21289 10.2752ZM10.1129 7.39774C10.0609 7.26837 10.0259 7.13277 10.009 6.99436C9.93735 6.33572 9.90819 5.67315 9.92173 5.01076C9.91615 4.7494 9.92425 4.48876 9.93811 4.2274C9.94371 4.153 9.97333 4.08244 10.0225 4.02634C10.0717 3.97024 10.1378 3.93164 10.2108 3.91636C10.2604 3.92666 10.3092 3.94062 10.3568 3.95812C10.4211 3.98699 10.4788 4.0289 10.5261 4.0812C10.5734 4.1335 10.6094 4.19505 10.6317 4.26196C10.7645 4.57683 10.8478 4.91035 10.8786 5.2507C10.8768 5.43129 10.8915 5.61168 10.9224 5.78962C10.9706 5.97844 10.8939 6.19894 11.0592 6.3577C11.2302 6.30784 11.4011 6.25708 11.5727 6.2074C11.6297 6.18897 11.6879 6.17407 11.7467 6.16276C11.8364 6.14714 11.9287 6.16063 12.0102 6.20124C12.0916 6.24186 12.158 6.30747 12.1994 6.38848C12.2445 6.46701 12.2639 6.55767 12.2548 6.64775C12.2458 6.73784 12.2088 6.82284 12.1491 6.89086C12.0684 6.97977 11.9684 7.04893 11.8567 7.093C11.4937 7.20897 11.1529 7.38545 10.8487 7.615C10.7615 7.68597 10.6535 7.72644 10.5411 7.7302C10.4448 7.7237 10.3527 7.68858 10.2765 7.62934C10.2003 7.57011 10.1435 7.48946 10.1134 7.39774H10.1129ZM7.03093 7.47658C6.94298 7.45347 6.86627 7.39954 6.81476 7.32461C6.76325 7.24967 6.74037 7.15872 6.7503 7.06834V6.92434C6.78126 6.77062 6.82681 6.53536 6.87487 6.30064C7.00555 5.65444 7.13587 5.00806 7.26979 4.36258C7.30201 4.20616 7.34179 4.05064 7.38553 3.8971C7.40741 3.8202 7.45009 3.75083 7.50888 3.69665C7.56767 3.64246 7.64028 3.60556 7.71871 3.59002C8.20471 3.44836 8.33071 3.47752 8.65759 3.86362C8.71196 3.92234 8.7602 3.98646 8.80158 4.05496C9.2019 4.79962 9.53274 5.56966 9.61248 6.42268C9.61585 6.56164 9.59484 6.70012 9.55039 6.83182C9.52792 6.89918 9.48628 6.95853 9.43058 7.00258C9.37489 7.04664 9.30756 7.0735 9.23683 7.07986C9.1762 7.08393 9.11561 7.0713 9.06166 7.04334C9.00771 7.01539 8.96246 6.97316 8.93083 6.92128C8.88254 6.85795 8.84412 6.78767 8.81689 6.71284C8.76415 6.5836 8.72329 6.44896 8.67289 6.31864C8.62249 6.18832 8.53321 6.15664 8.38363 6.2092C8.2918 6.24874 8.19795 6.28341 8.10247 6.31306C7.79881 6.38506 7.59955 6.53284 7.60603 6.88276C7.59683 7.00247 7.56507 7.11937 7.51243 7.22728C7.48763 7.30461 7.43873 7.37196 7.37288 7.41948C7.30703 7.467 7.22769 7.49218 7.14649 7.49134C7.10772 7.49075 7.06913 7.4858 7.03147 7.47658H7.03093ZM7.93777 5.03776C7.91336 5.09695 7.89525 5.15855 7.88376 5.22154C7.90176 5.26024 7.91113 5.32684 7.94911 5.35276C8.00311 5.38966 8.21803 5.2489 8.22559 5.18302C8.22877 5.1055 8.2159 5.02816 8.18781 4.95584C8.15972 4.88352 8.11699 4.81777 8.06232 4.76272C7.91868 4.80736 7.98852 4.94974 7.93812 5.03794L7.93777 5.03776ZM3.68706 6.71374C3.65365 6.59769 3.64988 6.47512 3.67608 6.35723C3.70227 6.23934 3.7576 6.1299 3.837 6.03892C3.86631 6.00436 3.90265 5.97645 3.94361 5.95706C3.98456 5.93767 4.02918 5.92724 4.07449 5.92648C4.11979 5.92571 4.16474 5.93462 4.20632 5.95262C4.24791 5.97061 4.28517 5.99727 4.31562 6.03082C4.38186 6.10545 4.43608 6.18991 4.47637 6.2812C4.50407 6.36839 4.5641 6.44167 4.64414 6.48599C4.72417 6.53031 4.81814 6.54231 4.90674 6.51952C5.04281 6.49363 5.17652 6.4566 5.30653 6.40882C5.32551 6.40332 5.34281 6.39313 5.35681 6.37917C5.37081 6.36522 5.38106 6.34796 5.38663 6.329C5.39219 6.31003 5.39287 6.28997 5.38863 6.27067C5.38438 6.25136 5.37533 6.23344 5.36232 6.21856C5.30806 6.13502 5.2456 6.05712 5.17585 5.986C5.02753 5.8519 4.86391 5.734 4.71397 5.6017C4.51604 5.43078 4.2726 5.32126 4.01341 5.28652C3.92896 5.27224 3.84929 5.23752 3.78134 5.18539C3.71338 5.13326 3.65921 5.06529 3.62355 4.98742C3.58789 4.90955 3.57182 4.82414 3.57674 4.73863C3.58166 4.65313 3.60743 4.57012 3.65179 4.49686C3.79983 4.18866 4.01025 3.91455 4.26972 3.6919C4.3606 3.62037 4.46511 3.56813 4.57686 3.53836C4.68861 3.5086 4.80525 3.50194 4.91966 3.51878C5.03408 3.53563 5.14385 3.57563 5.24228 3.63635C5.3407 3.69706 5.42571 3.77721 5.49211 3.8719C5.53634 3.92692 5.56054 3.99536 5.5607 4.06596C5.56087 4.13656 5.53699 4.20511 5.49301 4.26034C5.45441 4.31914 5.39577 4.36192 5.32798 4.38069C5.2602 4.39947 5.1879 4.39297 5.12455 4.3624C5.0698 4.33761 5.01765 4.30747 4.96885 4.2724C4.90367 4.22425 4.8224 4.20319 4.74204 4.21362C4.66168 4.22406 4.58847 4.26518 4.53775 4.32838C4.33813 4.50298 4.34659 4.6135 4.60975 4.6972C5.14664 4.87155 5.6231 5.19453 5.98387 5.6287C6.14991 5.80481 6.25732 6.02805 6.29131 6.2677C6.31123 6.39706 6.2992 6.52933 6.25628 6.65297C6.21336 6.77662 6.14085 6.88789 6.04507 6.97708C5.70259 7.29185 5.25507 7.46763 4.78993 7.4701C4.76527 7.4719 4.74043 7.4728 4.71541 7.4728C4.48487 7.47519 4.25983 7.40239 4.07438 7.26542C3.88892 7.12845 3.75314 6.93478 3.68761 6.71374H3.68706ZM12.6719 6.4936C12.6139 6.32355 12.5795 6.14633 12.5697 5.96692C12.5517 5.72734 12.5656 5.48596 12.5656 5.24494C12.585 4.86694 12.5157 4.48192 12.6518 4.11094C12.6716 4.034 12.6646 3.95262 12.632 3.88018C12.6166 3.84839 12.6078 3.81381 12.6061 3.77854C12.6045 3.74327 12.6099 3.70801 12.6222 3.6749C12.6344 3.64179 12.6533 3.61149 12.6775 3.58583C12.7018 3.56017 12.731 3.53968 12.7634 3.52558C13.1439 3.34677 13.5654 3.27335 13.984 3.313C14.0828 3.33011 14.1762 3.36992 14.257 3.42928C14.33 3.49361 14.3744 3.58423 14.3807 3.68128C14.3756 3.7295 14.3597 3.77597 14.3343 3.81725C14.3088 3.85853 14.2744 3.89357 14.2336 3.91978C14.0673 3.98694 13.8946 4.03688 13.7181 4.06882C13.6214 4.09078 13.516 4.07872 13.4217 4.10572C13.3984 4.11959 13.3787 4.13872 13.3642 4.16157C13.3497 4.18442 13.3408 4.21036 13.3381 4.2373C13.3428 4.29675 13.3586 4.35481 13.3846 4.40848C13.3886 4.4333 13.3978 4.45699 13.4116 4.47799C13.4255 4.49899 13.4436 4.51682 13.4648 4.5303C13.4861 4.54379 13.5099 4.55262 13.5348 4.55623C13.5597 4.55983 13.585 4.55813 13.6092 4.55122C13.8027 4.4966 14.008 4.50049 14.1992 4.56238C14.2679 4.57811 14.3306 4.61328 14.3797 4.66368C14.4289 4.71409 14.4626 4.77759 14.4766 4.8466C14.4892 4.92671 14.4761 5.00873 14.4393 5.08098C14.4025 5.15322 14.3438 5.21199 14.2716 5.2489C14.1268 5.31669 13.9762 5.37122 13.8216 5.4118C13.5313 5.49334 13.5125 5.5126 13.5336 5.81608C13.5433 5.96008 13.5962 5.99716 13.7167 5.94046C13.8427 5.8807 13.9667 5.81284 14.0958 5.75866C14.3085 5.66866 14.498 5.75362 14.641 5.99266C14.6821 6.07367 14.6929 6.16672 14.6714 6.25498C14.6499 6.34325 14.5975 6.42093 14.5238 6.47398C14.2627 6.66006 13.9831 6.81858 13.6893 6.94702C13.5777 6.99099 13.459 7.0144 13.339 7.01614C13.1856 7.01554 13.0368 6.96384 12.916 6.86921C12.7952 6.77459 12.7094 6.64243 12.6721 6.4936H12.6719Z" fill="black" />
                    </svg>

                    Sale Type
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.75 15.2913H5.44495C6.20309 15.2913 6.9694 15.3703 7.70723 15.5223C9.01245 15.7912 10.3866 15.8237 11.7052 15.6104C12.3553 15.5051 12.9945 15.3442 13.5731 15.0649C14.0954 14.8128 14.7352 14.4575 15.1649 14.0594C15.5941 13.662 16.041 13.0115 16.3582 12.503C16.6302 12.0671 16.4986 11.5322 16.0684 11.2073C15.5905 10.8464 14.8813 10.8465 14.4034 11.2075L13.048 12.2313C12.5227 12.6281 11.949 12.9934 11.2654 13.1024C11.1832 13.1156 11.0971 13.1275 11.0073 13.1379M11.0073 13.1379C10.9802 13.1411 10.9528 13.1441 10.9251 13.1469M11.0073 13.1379C11.1166 13.1145 11.2252 13.047 11.3271 12.9581C11.8095 12.5371 11.8399 11.8275 11.4214 11.3573C11.3243 11.2483 11.2106 11.1573 11.0843 11.0819C8.98627 9.83057 5.72206 10.7837 3.75 12.1822M11.0073 13.1379C10.9799 13.1438 10.9525 13.1469 10.9251 13.1469M10.9251 13.1469C10.5325 13.1872 10.0734 13.1976 9.56385 13.1495" stroke="black" stroke-linecap="round" />
                      <path d="M3.75 11.625C3.75 11.0037 3.24632 10.5 2.625 10.5C2.00368 10.5 1.5 11.0037 1.5 11.625V15.375C1.5 15.9963 2.00368 16.5 2.625 16.5C3.24632 16.5 3.75 15.9963 3.75 15.375V11.625Z" stroke="black" />
                      <path d="M10.0443 4.35873L6.2998 8.10039L7.1998 9.00039M7.6498 6.75039L8.5498 7.65039M13.4998 2.92539C13.4998 4.04377 12.5932 4.95039 11.4748 4.95039C10.3564 4.95039 9.4498 4.04377 9.4498 2.92539C9.4498 1.80701 10.3564 0.900391 11.4748 0.900391C12.5932 0.900391 13.4998 1.80701 13.4998 2.92539Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    Possission Status
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.93438 3.80644C3.93438 2.91025 4.65833 2.1875 5.56901 2.1875C6.47389 2.1875 7.20365 2.91025 7.20365 3.80644C7.19784 4.70844 6.46808 5.42538 5.56901 5.42538C4.66414 5.42538 3.93438 4.70263 3.93438 3.80644ZM12.951 10.75H9.98498V8.125C9.98498 6.84619 8.85658 5.8125 7.58695 5.8125H3.61128C2.21739 5.8125 1.0233 7.00875 1.02393 8.1875V13C1.02229 13.5333 1.40263 13.8118 1.7812 13.8125C2.16072 13.8132 2.53847 13.5347 2.53847 13V8.3125H3.04332V13.8125H7.96559V8.3125H8.47043L8.47555 11.4606C8.4722 12.0062 8.81266 12.2385 9.1646 12.25H12.951C13.9836 12.25 13.9836 10.75 12.951 10.75ZM16.8356 6.41831L15.4481 5.16081V3.68581H14.6284V4.418L13.6694 3.55313L10.4765 6.38113C10.3962 6.44481 10.3426 6.55094 10.3426 6.66231C10.3426 6.86394 10.5087 7.02313 10.7069 7.02313C10.8033 7.02313 10.8944 6.986 10.9587 6.92231L11.4516 6.48194V9.87763H13.0064V7.50306H14.3269V9.87769H15.8606V6.5085L16.2891 6.90113C16.3534 6.97538 16.4552 7.02319 16.5624 7.02319C16.766 7.02319 16.9267 6.85869 16.9267 6.66238C16.9266 6.56688 16.8945 6.48194 16.8356 6.41831Z" stroke="black" />
                    </svg>

                    Listed By
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5002 8.33333L9.16683 11.6667L7.50016 10M3.3335 4.16667V10.0464C3.3335 12.5716 4.76018 14.88 7.01874 16.0092L10.0002 17.5L12.9816 16.0092C15.2402 14.88 16.6668 12.5716 16.6668 10.0464V4.16667L16.086 4.2312C14.0453 4.45794 11.9928 3.92335 10.3221 2.72995L10.0002 2.5L9.67825 2.72995C8.00748 3.92335 5.95496 4.45794 3.91432 4.2312L3.3335 4.16667Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Verified
                  </button>
                </h2>
                <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.3335 5V4.16667C13.3335 3.72464 13.1579 3.30072 12.8453 2.98816C12.5328 2.67559 12.1089 2.5 11.6668 2.5H7.50016C7.05814 2.5 6.63421 2.67559 6.32165 2.98816C6.00909 3.30072 5.8335 3.72464 5.8335 4.16667V17.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.1665 17.5H7.49984M14.9998 13.3333V11.6667M11.6665 13.3333V11.6667M15.8332 8.33333H10.8332V7.5C10.8332 6.83696 11.0966 6.20107 11.5654 5.73223C12.0342 5.26339 12.6701 5 13.3332 5C13.9962 5 14.6321 5.26339 15.1009 5.73223C15.5698 6.20107 15.8332 6.83696 15.8332 7.5V8.33333Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    Bathrooms
                  </button>
                </h2>
                <div id="collapseEight" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineth" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1267_4715)">
                        <path d="M15.1876 17.3317V10.2684C15.5713 10.1678 15.9222 9.9652 16.2046 9.68116C16.487 9.39712 16.6908 9.04175 16.7954 8.65114C16.9 8.26052 16.9017 7.84857 16.8002 7.45711C16.6987 7.06565 16.4976 6.70861 16.2175 6.42224C15.9373 6.13587 15.5881 5.93038 15.2051 5.82661C14.8222 5.72285 14.4192 5.72452 14.037 5.83144C13.6549 5.93836 13.3073 6.14674 13.0294 6.43541C12.7515 6.72408 12.5533 7.08276 12.4549 7.47506H5.54518C5.44677 7.08276 5.24857 6.72408 4.9707 6.43541C4.69283 6.14674 4.34519 5.93836 3.96307 5.83144C3.58095 5.72452 3.17795 5.72285 2.795 5.82661C2.41204 5.93038 2.06277 6.13587 1.78263 6.42224C1.50249 6.70861 1.30146 7.06565 1.19995 7.45711C1.09844 7.84857 1.10007 8.26052 1.20467 8.65114C1.30927 9.04175 1.51311 9.39712 1.79551 9.68116C2.0779 9.9652 2.42879 10.1678 2.81255 10.2684V17.3317C2.42879 17.4323 2.0779 17.6349 1.79551 17.9189C1.51311 18.203 1.30927 18.5584 1.20467 18.949C1.10007 19.3396 1.09844 19.7515 1.19995 20.143C1.30146 20.5345 1.50249 20.8915 1.78263 21.1779C2.06277 21.4642 2.41204 21.6697 2.795 21.7735C3.17795 21.8773 3.58095 21.8756 3.96307 21.7687C4.34519 21.6617 4.69283 21.4534 4.9707 21.1647C5.24857 20.876 5.44677 20.5173 5.54518 20.1251H12.4549C12.5533 20.5173 12.7515 20.876 13.0294 21.1647C13.3073 21.4534 13.6549 21.6617 14.037 21.7687C14.4192 21.8756 14.8222 21.8773 15.2051 21.7735C15.5881 21.6697 15.9373 21.4642 16.2175 21.1779C16.4976 20.8915 16.6987 20.5345 16.8002 20.143C16.9017 19.7515 16.9 19.3396 16.7954 18.949C16.6908 18.5584 16.487 18.203 16.2046 17.9189C15.9222 17.6349 15.5713 17.4323 15.1876 17.3317ZM14.6251 6.90006C14.8476 6.90006 15.0651 6.9675 15.2501 7.09387C15.4351 7.22023 15.5793 7.39983 15.6644 7.60997C15.7496 7.8201 15.7718 8.05133 15.7284 8.27441C15.685 8.49749 15.5779 8.7024 15.4205 8.86323C15.2632 9.02406 15.0628 9.13359 14.8445 9.17796C14.6263 9.22233 14.4001 9.19956 14.1945 9.11252C13.989 9.02548 13.8133 8.87808 13.6897 8.68896C13.566 8.49984 13.5001 8.2775 13.5001 8.05006C13.5004 7.74516 13.619 7.45286 13.8299 7.23727C14.0408 7.02168 14.3268 6.90041 14.6251 6.90006ZM2.25005 8.05006C2.25005 7.82261 2.31603 7.60027 2.43965 7.41115C2.56327 7.22203 2.73897 7.07463 2.94454 6.98759C3.1501 6.90055 3.3763 6.87778 3.59453 6.92215C3.81276 6.96652 4.01322 7.07605 4.17055 7.23688C4.32788 7.39771 4.43503 7.60262 4.47844 7.8257C4.52185 8.04878 4.49957 8.28001 4.41442 8.49014C4.32927 8.70028 4.18508 8.87988 4.00007 9.00624C3.81506 9.13261 3.59756 9.20006 3.37505 9.20006C3.07678 9.19975 2.7908 9.07849 2.57989 8.86289C2.36897 8.64729 2.25035 8.35496 2.25005 8.05006ZM3.37505 20.7001C3.15255 20.7001 2.93504 20.6326 2.75004 20.5062C2.56503 20.3799 2.42084 20.2003 2.33569 19.9901C2.25054 19.78 2.22826 19.5488 2.27167 19.3257C2.31508 19.1026 2.42222 18.8977 2.57956 18.7369C2.73689 18.5761 2.93735 18.4665 3.15558 18.4222C3.37381 18.3778 3.60001 18.4006 3.80557 18.4876C4.01114 18.5746 4.18684 18.722 4.31046 18.9111C4.43407 19.1003 4.50005 19.3226 4.50005 19.5501C4.49971 19.8549 4.38108 20.1473 4.17017 20.3628C3.95927 20.5784 3.67332 20.6997 3.37505 20.7001ZM12.4549 18.9751H5.54518C5.44444 18.5797 5.24235 18.219 4.95975 17.9301C4.67716 17.6413 4.3243 17.4347 3.93755 17.3317V10.2684C4.32427 10.1654 4.6771 9.95877 4.95969 9.6699C5.24227 9.38104 5.44438 9.02036 5.54518 8.62506H12.4549C12.5557 9.02039 12.7578 9.3811 13.0404 9.66997C13.3229 9.95884 13.6758 10.1654 14.0626 10.2684V17.3317C13.6758 17.4347 13.3229 17.6412 13.0403 17.9301C12.7577 18.219 12.5556 18.5797 12.4549 18.9751ZM14.6251 20.7001C14.4025 20.7001 14.185 20.6326 14 20.5062C13.815 20.3799 13.6708 20.2003 13.5857 19.9901C13.5005 19.78 13.4783 19.5488 13.5217 19.3257C13.5651 19.1026 13.6722 18.8977 13.8296 18.7369C13.9869 18.5761 14.1873 18.4665 14.4056 18.4222C14.6238 18.3778 14.85 18.4006 15.0556 18.4876C15.2611 18.5746 15.4368 18.722 15.5605 18.9111C15.6841 19.1003 15.7501 19.3226 15.7501 19.5501C15.7497 19.8549 15.631 20.1472 15.4201 20.3628C15.2092 20.5784 14.9233 20.6996 14.6251 20.7001Z" fill="black" />
                        <path d="M9.04551 5.42809C10.1639 5.42809 11.0705 4.50132 11.0705 3.35809C11.0705 2.21486 10.1639 1.28809 9.04551 1.28809C7.92713 1.28809 7.02051 2.21486 7.02051 3.35809C7.02051 4.50132 7.92713 5.42809 9.04551 5.42809Z" fill="black" stroke="black" stroke-miterlimit="10" stroke-linecap="round" />
                        <path d="M9 5.51953V13.7995" stroke="black" stroke-miterlimit="10" stroke-linecap="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1267_4715">
                          <rect width="18" height="23" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>


                    Built Up Area (Sq.Ft.)
                  </button>
                </h2>
                <div id="collapseNineth" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTenth" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1267_4726)">
                        <path d="M2.40006 18.0004V12.1851H0L9.00006 5.40039L18 12.1849H15.6001V18.0003H10.8V13.6388H7.20007V18.0003L2.40006 18.0004Z" stroke="black" stroke-miterlimit="5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.70036 7.86035C2.53467 7.86035 2.40036 7.99466 2.40036 8.16035C2.40036 8.32604 2.53467 8.46035 2.70036 8.46035V7.86035ZM2.70336 8.46035C2.86905 8.46035 3.00336 8.32604 3.00336 8.16035C3.00336 7.99466 2.86905 7.86035 2.70336 7.86035V8.46035ZM3.50751 7.27235C3.63009 7.38383 3.81981 7.37486 3.93129 7.25231C4.0428 7.12973 4.0338 6.94001 3.91125 6.8285L3.50751 7.27235ZM4.51653 6.16244C4.63908 6.27392 4.82883 6.26495 4.94031 6.14237C5.05182 6.01982 5.04282 5.83007 4.92027 5.71859L4.51653 6.16244ZM1.48948 6.8285C1.36691 6.94001 1.35793 7.12973 1.46942 7.25231C1.58091 7.37486 1.77065 7.38383 1.89321 7.27235L1.48948 6.8285ZM0.48046 5.71859C0.357895 5.83007 0.348916 6.01982 0.460402 6.14237C0.571891 6.26495 0.761629 6.27392 0.884194 6.16244L0.48046 5.71859ZM2.70036 8.46035H2.70336V7.86035H2.70036V8.46035ZM2.70036 6.96035C3.01137 6.96035 3.29415 7.07828 3.50751 7.27235L3.91125 6.8285C3.59175 6.53789 3.16644 6.36035 2.70036 6.36035V6.96035ZM2.70036 5.46035C3.39993 5.46035 4.03674 5.726 4.51653 6.16244L4.92027 5.71859C4.33434 5.18561 3.55497 4.86035 2.70036 4.86035V5.46035ZM1.89321 7.27235C2.10656 7.07828 2.38935 6.96035 2.70036 6.96035V6.36035C2.23428 6.36035 1.80897 6.53789 1.48948 6.8285L1.89321 7.27235ZM0.884194 6.16244C1.36399 5.726 2.0008 5.46035 2.70036 5.46035V4.86035C1.84574 4.86035 1.06639 5.18561 0.48046 5.71859L0.884194 6.16244Z" fill="black" />
                        <path d="M15.1202 8.40016C14.7383 8.40016 14.372 8.24845 14.1019 7.9784C13.8319 7.70835 13.6802 7.34208 13.6802 6.96016C13.6802 6.00016 15.1202 4.36816 15.1202 4.36816C15.1202 4.36816 16.5602 6.00016 16.5602 6.96016C16.5602 7.34208 16.4085 7.70835 16.1384 7.9784C15.8684 8.24845 15.5021 8.40016 15.1202 8.40016Z" fill="black" />
                        <path d="M8.99981 1.44043C8.00564 1.44043 7.19971 2.24637 7.19971 3.24053C7.19971 3.73063 7.39557 4.17497 7.71328 4.4996C7.83703 4.62604 7.93876 4.77649 7.97347 4.94998L8.16396 5.90195C8.2313 6.2385 8.52682 6.48072 8.87002 6.48072H9.1296C9.47281 6.48072 9.76831 6.2385 9.83567 5.90195L10.0262 4.94998C10.0609 4.77649 10.1626 4.62604 10.2863 4.4996C10.6041 4.17497 10.7999 3.73063 10.7999 3.24053C10.7999 2.24637 9.99397 1.44043 8.99981 1.44043Z" stroke="black" stroke-width="0.7" />
                        <path d="M9.00049 0.359956V0" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.1606 1.07968L11.5206 0.719727" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.8809 3.24023H12.2408" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.11972 3.24023H5.75977" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.47998 0.719727L6.83994 1.07968" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.27979 5.04004H9.71961" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1267_4726">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Amenities
                  </button>
                </h2>
                <div id="collapseTenth" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleventh" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1278_4761)">
                        <path d="M13.5999 0.85C13.5999 0.380558 13.9804 0 14.4499 0C14.9194 0 15.2999 0.380558 15.2999 0.85V1.7H16.1499C16.6194 1.7 16.9999 2.08056 16.9999 2.55C16.9999 3.01944 16.6194 3.4 16.1499 3.4H15.2999V4.25C15.2999 4.71944 14.9194 5.1 14.4499 5.1C13.9804 5.1 13.5999 4.71944 13.5999 4.25V3.4H12.7499C12.2804 3.4 11.8999 3.01944 11.8999 2.55C11.8999 2.08056 12.2804 1.7 12.7499 1.7H13.5999V0.85Z" fill="black" />
                        <path d="M15.0123 5.71921C15.3721 5.56559 15.7939 5.73107 15.9142 6.10331C16.3946 7.58933 16.4188 9.19143 15.9747 10.7C15.4637 12.436 14.3643 13.94 12.8654 14.9538C11.3664 15.9676 9.56127 16.4281 7.75983 16.2561C5.95843 16.0842 4.27303 15.2905 2.99291 14.0115C1.71279 12.7325 0.917793 11.0477 0.744372 9.2464C0.570946 7.44511 1.02991 5.63962 2.04248 4.13982C3.05506 2.64002 4.5581 1.53944 6.29364 1.02697C7.80191 0.581621 9.40394 0.604563 10.8904 1.08368C11.2628 1.20369 11.4286 1.62531 11.2753 1.98521C11.1219 2.34512 10.7056 2.51069 10.3309 2.39826C9.15072 2.04411 7.88769 2.03847 6.6962 2.39029C5.27729 2.80926 4.04846 3.70906 3.22062 4.93523C2.39278 6.1614 2.01754 7.63749 2.15933 9.11019C2.30112 10.5828 2.95107 11.9602 3.99765 13.0059C5.04422 14.0517 6.42215 14.7004 7.89491 14.841C9.36768 14.9816 10.8435 14.6052 12.069 13.7763C13.2945 12.9474 14.1933 11.7178 14.611 10.2986C14.9619 9.10686 14.9552 7.84376 14.6001 6.66386C14.4874 6.28926 14.6526 5.87282 15.0123 5.71921Z" fill="black" />
                        <path d="M5.46164 6.47718L5.16688 6.62457C4.74564 6.83519 4.25 6.52887 4.25 6.0579C4.25 5.81792 4.38558 5.59855 4.60021 5.49123L5.5171 5.03279C5.61546 4.98361 5.72391 4.95801 5.83388 4.95801H6.375C6.7662 4.95801 7.08333 5.27514 7.08333 5.66634V11.333C7.08333 11.7242 6.7662 12.0413 6.375 12.0413C5.9838 12.0413 5.66667 11.7242 5.66667 11.333V6.6039C5.66667 6.49858 5.55583 6.43009 5.46164 6.47718Z" fill="black" />
                        <path d="M9.20833 6.37467H11.1167C11.2189 6.37467 11.2874 6.47953 11.2465 6.57312L9.35007 10.9078C9.11618 11.4424 9.50789 12.0413 10.0914 12.0413C10.4151 12.0413 10.7077 11.8485 10.8352 11.5509L12.4636 7.75118C12.6525 7.31031 12.75 6.83569 12.75 6.35605V5.66634C12.75 5.27514 12.4329 4.95801 12.0417 4.95801H9.20833C8.81712 4.95801 8.5 5.27514 8.5 5.66634C8.5 6.05754 8.81712 6.37467 9.20833 6.37467Z" fill="black" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1278_4761">
                          <rect width="17" height="17" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Age of Property
                  </button>
                </h2>
                <div id="collapseEleventh" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelfth" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.8957 9.68294V0.892578H5.32129V14.1726H9.6081" fill="white" />
                      <path d="M10.6251 14.8645C12.5029 14.8645 14.0251 13.3422 14.0251 11.4645C14.0251 9.58668 12.5029 8.06445 10.6251 8.06445C8.74733 8.06445 7.2251 9.58668 7.2251 11.4645C7.2251 13.3422 8.74733 14.8645 10.6251 14.8645Z" fill="#D0CFCE" />
                      <path d="M13.6003 8.92559V0.850586H2.55029V14.4506H8.07478" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.25049 2.55078H7.65049" stroke="black" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round" />
                      <path d="M4.25 1.70117H7.65" stroke="black" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round" />
                      <path d="M4.25 4.25L12.75 4.25" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.25 5.95117L12.75 5.95117" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.25049 7.65039L12.7505 7.65039" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.25049 9.35059L7.65049 9.35059" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.80049 11.0508L4.25049 11.0508" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.8 12.75L4.25 12.75" stroke="black" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.6253 15.3004C12.7378 15.3004 14.4503 13.5879 14.4503 11.4754C14.4503 9.3629 12.7378 7.65039 10.6253 7.65039C8.5128 7.65039 6.80029 9.3629 6.80029 11.4754C6.80029 13.5879 8.5128 15.3004 10.6253 15.3004Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M13.6006 14.4512L16.1506 16.1512" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.80029 11.0508L12.1003 11.0508" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7.65039 9.35059L11.7504 9.35059" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.9707 12.75L12.0707 12.75" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Property Details
                  </button>
                </h2>
                <div id="collapseTwelfth" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteenth" aria-expanded="false" aria-controls="collapseThree">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.3584 17.8855C12.3577 18.0483 12.2925 18.2042 12.1769 18.3193C12.0613 18.4344 11.9047 18.4993 11.7413 18.5H2.1171C1.95365 18.4993 1.79708 18.4344 1.6815 18.3193C1.56592 18.2042 1.50068 18.0483 1.5 17.8855V16.7691C1.50068 16.6064 1.56592 16.4505 1.6815 16.3354C1.79708 16.2203 1.95365 16.1553 2.1171 16.1547H11.7413C11.9048 16.155 12.0616 16.2199 12.1773 16.335C12.2929 16.4502 12.358 16.6063 12.3584 16.7691V17.8855ZM8.76361 14.5389C8.66894 14.539 8.57521 14.5204 8.4878 14.4842C8.40039 14.448 8.32105 14.3949 8.25434 14.3281L4.10092 10.1937C3.96585 10.0592 3.88997 9.87675 3.88997 9.68655C3.88997 9.49635 3.96585 9.31394 4.10092 9.17945C4.23599 9.04496 4.41918 8.96941 4.61019 8.96941C4.8012 8.96941 4.98439 9.04496 5.11946 9.17945L9.27158 13.3165C9.37237 13.4167 9.44103 13.5444 9.46886 13.6836C9.49669 13.8227 9.48243 13.9669 9.4279 14.0979C9.37337 14.2289 9.28101 14.3409 9.16253 14.4197C9.04404 14.4984 8.90476 14.5404 8.76231 14.5402L8.76361 14.5389ZM18.2865 15.8222L12.513 10.0721L13.9226 8.66977L9.80034 4.5651L5.94183 8.40716L10.0641 12.5105L11.4957 11.0863L17.2705 16.8364C17.3374 16.903 17.4168 16.9558 17.5042 16.9919C17.5915 17.0279 17.6852 17.0465 17.7798 17.0465C17.8744 17.0465 17.968 17.0279 18.0554 16.9919C18.1428 16.9558 18.2222 16.903 18.2891 16.8364C18.3559 16.7698 18.409 16.6908 18.4452 16.6037C18.4814 16.5167 18.5 16.4235 18.5 16.3293C18.5 16.2351 18.4814 16.1419 18.4452 16.0549C18.409 15.9679 18.3559 15.8888 18.2891 15.8222H18.2865ZM15.2594 8.06952C15.1651 8.06958 15.0716 8.0511 14.9845 8.01514C14.8973 7.97918 14.8181 7.92645 14.7514 7.85996L10.5967 3.72425C10.5298 3.65765 10.4768 3.5786 10.4406 3.49159C10.4044 3.40458 10.3858 3.31132 10.3858 3.21715C10.3858 3.12297 10.4044 3.02972 10.4406 2.94271C10.4768 2.8557 10.5298 2.77664 10.5967 2.71005C10.6636 2.64345 10.743 2.59063 10.8304 2.55459C10.9178 2.51855 11.0114 2.5 11.106 2.5C11.2006 2.5 11.2942 2.51855 11.3816 2.55459C11.469 2.59063 11.5484 2.64345 11.6153 2.71005L15.7674 6.84576C15.8681 6.94591 15.9367 7.07355 15.9646 7.21254C15.9925 7.35153 15.9783 7.49562 15.924 7.62661C15.8696 7.75759 15.7774 7.86958 15.6591 7.94842C15.5409 8.02726 15.4017 8.0694 15.2594 8.06952Z" fill="black" />
                    </svg>
                    RERA Compliant
                  </button>
                </h2>
                <div id="collapseThirteenth" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <ul>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                      <li>
                        <input type='checkbox' />
                        <span>Subscription Plans</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>


        <div className='col-md-6 mid'>
          <div className='property-section'>


            <div className='row'>
              <div className='page-address breadcrumb col-md-9'>
                <div className='address-path'>

                  <span>Home</span>

                  <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  </span>

                  <span>Jaipur</span>

                  <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  </span>

                  <span className='last-path'>Flats for Sale in Jagatpura</span>

                </div>
                <div className='pagination'>
                  Showing 1-30 of 1028
                </div>
              </div>
              <div className="dropdown col-md-3">
                <div className="dropdown-toggle1" onClick={toggleMenu}>
                  <span>Sort</span>
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8024 6.63184H2.13574"
                      stroke="#1C274C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M16.3024 10.7988H4.63574"
                      stroke="#1C274C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M13.8024 14.9658H7.13574"
                      stroke="#1C274C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                {isMenuOpen && (
                  <div className="dropdown-menu">
                    <div className="menu-item">Relevance</div>
                    <div className="menu-item">
                      <span>Price</span>
                      <i className="fas fa-arrow-up"></i>
                    </div>
                    <div className="menu-item">
                      <span>Price</span>
                      <i className="fas fa-arrow-down"></i>
                    </div>
                    <div className="menu-item">
                      <span>Area</span>
                      <i className="fas fa-arrow-up"></i>
                    </div>
                    <div className="menu-item">
                      <span>Area</span>
                      <i className="fas fa-arrow-down"></i>
                    </div>
                    <div className="menu-item">Last Updated</div>
                    <div className="menu-item">Date Added</div>
                  </div>
                )}
              </div>
            </div>

            <LoadingSkeleton />


            {list?.length > 0 && (
              list?.map((project, index) => (

                <div className="card mt-3" key={index}>
                  <div className='row'>
                    <div className='col-md-4 propimgbox'>
                      <span className='rera'>RERA</span>
                      <img src={process.env.REACT_APP_IMAGE_PATH + "property/images/" + project?.images[0]} className="card-img-top" alt="..." />
                    </div>
                    <div className='col-md-8'>
                      <div className="card-header">
                        <h3>{project.project_name}</h3>
                        <div className='header-btntray'>
                          <Link to="/">
                            <div>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.25 13.375H13.2588M13.6 10.75H14.125C14.9404 10.75 15.3481 10.75 15.6697 10.8832C16.0985 11.0608 16.4392 11.4015 16.6168 11.8303C16.75 12.1519 16.75 12.5596 16.75 13.375C16.75 14.1904 16.75 14.5981 16.6168 14.9197C16.4392 15.3485 16.0985 15.6892 15.6697 15.8668C15.3481 16 14.9404 16 14.125 16H3.625C2.80961 16 2.40191 16 2.0803 15.8668C1.65151 15.6892 1.31083 15.3485 1.13321 14.9197C1 14.5981 1 14.1904 1 13.375C1 12.5596 1 12.1519 1.13321 11.8303C1.31083 11.4015 1.65151 11.0608 2.0803 10.8832C2.40191 10.75 2.80961 10.75 3.625 10.75H4.15M8.875 11.625V2M8.875 11.625L6.25 9M8.875 11.625L11.5 9" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </div>
                          </Link>

                          <Link to="/">
                            <div>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3746 3.66666C10.3746 2.1939 11.5932 1 13.0964 1C14.5996 1 15.8182 2.1939 15.8182 3.66666C15.8182 5.13942 14.5996 6.33334 13.0964 6.33334C12.3374 6.33334 11.6514 6.02877 11.1583 5.53878L7.39047 8.0636C7.42526 8.234 7.44355 8.41 7.44355 8.58976C7.44355 8.94576 7.37202 9.28608 7.24245 9.59712L11.3738 12.2686C11.8428 11.8929 12.4427 11.6666 13.0964 11.6666C14.5996 11.6666 15.8182 12.8606 15.8182 14.3334C15.8182 15.8061 14.5996 17 13.0964 17C11.5932 17 10.3746 15.8061 10.3746 14.3334C10.3746 13.9476 10.4585 13.5804 10.6093 13.2489L6.51129 10.599C6.03325 11.0078 5.40708 11.2564 4.72176 11.2564C3.21858 11.2564 2 10.0625 2 8.58976C2 7.11698 3.21858 5.92308 4.72176 5.92308C5.58614 5.92308 6.3556 6.3178 6.8538 6.93214L10.5054 4.48514C10.4205 4.22687 10.3746 3.95168 10.3746 3.66666Z" fill="#343434" />
                              </svg>
                            </div>
                          </Link>

                          <Link to="/">
                            <div>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.465 15.6077C9.21 15.6977 8.79 15.6977 8.535 15.6077C6.36 14.8652 1.5 11.7677 1.5 6.51769C1.5 4.20019 3.3675 2.3252 5.67 2.3252C7.035 2.3252 8.2425 2.9852 9 4.0052C9.38533 3.4846 9.88723 3.06149 10.4655 2.76975C11.0438 2.47802 11.6823 2.32576 12.33 2.3252C14.6325 2.3252 16.5 4.20019 16.5 6.51769C16.5 11.7677 11.64 14.8652 9.465 15.6077Z" stroke="#343434" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="card-body">

                        <div className='property-pricing'>
                          <span>₹69 L - 1.67 Cr</span>
                          <span className='property-emi'>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4688 0V14H1.53125V0H12.4688ZM5.03125 10.5H3.71875V11.8125H5.03125V10.5ZM7.65625 10.5H6.34375V11.8125H7.65625V10.5ZM10.2812 10.5H8.96875V11.8125H10.2812V10.5ZM5.03125 7.875H3.71875V9.1875H5.03125V7.875ZM7.65625 7.875H6.34375V9.1875H7.65625V7.875ZM10.2812 7.875H8.96875V9.1875H10.2812V7.875ZM5.03125 5.25H3.71875V6.5625H5.03125V5.25ZM7.65625 5.25H6.34375V6.5625H7.65625V5.25ZM10.2812 5.25H8.96875V6.5625H10.2812V5.25ZM11.1562 1.3125H2.84375V3.9375H11.1562V1.3125Z" fill="#EB622E" />
                            </svg>
                            (EMI starts at ₹36.59 K)
                          </span>
                        </div>

                        <p className='property-description line-clamp'>
                          Residential project, Sankalp The Index in Jaipur is offering units for sale in Jagatpura. Check out some Apartment that suit your lifestyle and liking...
                        </p>

                        <ul className='detail-box'>
                          <li>
                            <div className="detail">
                              <h5 className="detail-title">Possession Date</h5>
                              <p className="detail-text">Oct, 2023</p>
                            </div>
                          </li>
                          <li>
                            <div className="detail">
                              <h5 className="detail-title">Average Price</h5>
                              <p className="detail-text">₹6.5 K/sq.ft</p>
                            </div>
                          </li>
                          <li>
                            <div className="detail">
                              <h5 className="detail-title">Sizes</h5>
                              <p className="detail-text">1063 - 2564 sq.ft.</p>
                            </div>
                          </li>
                          <li>
                            <div className="detail">
                              <h5 className="detail-title">Locality</h5>
                              <p className="detail-text">Jagatpura</p>
                            </div>
                          </li>
                        </ul>

                      </div>
                    </div>
                  </div>

                  <div className="card-footer builder-info">
                    <div className='builderimg'>
                      <img src={builderlogo} className="card-img-top" alt="..." />
                    </div>

                    <div className='builder-name'>
                      <h5>Sankalp Builder</h5>
                    </div>

                    <button className='btn contseller-btn'>
                      Contact Seller
                    </button>
                  </div>
                </div>
              ))
            )}



          </div>

        </div>


        <div className='col-md-3 right'>
          <div className='ad-sidebar'>
            <div className="card">
              <div className='imgbox'>
                <span className='price'>₹ 55 L - 1.50 L</span>
                <span className='ad'>AD</span>
                <img src={adimg1} className="card-img-top" alt="..." />
              </div>
              <div className="card-body">
                <h5 className="card-title">Alora</h5>
                <div className='d-flex justify-content-between'>
                  <div className=''>
                    <p className="card-text">Malviya Nagar</p>
                  </div>
                  <div className='icon d-flex'>
                    <Link to="/">
                      <div>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.87937 2.13157C6.54763 1.46331 7.45398 1.08789 8.39907 1.08789C10.367 1.08789 11.9624 2.68326 11.9624 4.65125C11.9624 5.59631 11.587 6.50266 10.9187 7.17092L9.52518 8.56445L8.56396 7.60323L9.95753 6.2097C10.3708 5.79637 10.603 5.23578 10.603 4.65125C10.603 3.43402 9.61626 2.44727 8.39907 2.44727C7.81451 2.44727 7.25392 2.67947 6.8406 3.0928L5.44706 4.48633L4.48584 3.52511L5.87937 2.13157Z" fill="white" />
                          <path d="M6.20921 9.95802L7.60274 8.56445L8.56396 9.52567L7.17044 10.9192C6.50217 11.5875 5.59582 11.9629 4.65076 11.9629C2.68277 11.9629 1.0874 10.3675 1.0874 8.39956C1.0874 7.45448 1.46283 6.54812 2.13108 5.87986L3.52462 4.48633L4.48584 5.44755L3.09231 6.84108C2.67898 7.25441 2.44678 7.815 2.44678 8.39956C2.44678 9.61674 3.43353 10.6035 4.65076 10.6035C5.23529 10.6035 5.79588 10.3713 6.20921 9.95802Z" fill="white" />
                          <path d="M4.9666 9.04423L9.04472 4.96611L8.0835 4.00488L4.00537 8.08301L4.9666 9.04423Z" fill="white" />
                        </svg>
                      </div>
                    </Link>
                    <Link to="/">
                      <div>
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.51285 9.83715L9.5128 9.83717C9.31607 9.95039 9.10067 9.96504 8.93998 9.97597C8.92562 9.97694 8.91169 9.97789 8.89826 9.97888C8.707 9.9929 8.51399 10 8.31944 10C4.00089 10 0.5 6.49911 0.5 2.18056C0.5 1.98597 0.507119 1.79297 0.521116 1.6018L0.521116 1.6018C0.522099 1.58839 0.523043 1.57449 0.524017 1.56015C0.534938 1.39941 0.549578 1.18391 0.662878 0.98712L0.662885 0.987107C0.757679 0.822473 0.912034 0.679012 1.08314 0.596499L1.08316 0.596493C1.28823 0.497608 1.51671 0.498867 1.69002 0.499822C1.7064 0.499912 1.72229 0.5 1.73762 0.5H3.06801C3.08112 0.5 3.09468 0.499938 3.10865 0.499874C3.25375 0.499213 3.44241 0.498352 3.61496 0.564606L3.61497 0.564608C3.76358 0.621674 3.89591 0.714361 4.00034 0.834536L4.00034 0.834538C4.12157 0.974048 4.18523 1.15164 4.2342 1.28822C4.23891 1.30138 4.24349 1.31415 4.24797 1.32647L4.24798 1.32648L4.79864 2.84082L4.79865 2.84085C4.80023 2.84519 4.80181 2.84953 4.80338 2.85387C4.83721 2.94688 4.87124 3.04043 4.89451 3.12311C4.92058 3.21571 4.9433 3.32759 4.93498 3.4557L4.93498 3.45572C4.9233 3.63543 4.86192 3.80817 4.75798 3.95483L9.51285 9.83715ZM9.51285 9.83715C9.67758 9.74233 9.82096 9.58793 9.90343 9.41695L9.51285 9.83715ZM9.17352 6.25202L9.17357 6.25203C9.1859 6.25652 9.19869 6.26111 9.21186 6.26583C9.34836 6.31477 9.52598 6.37845 9.66546 6.49967C9.66548 6.49968 9.6655 6.4997 9.66552 6.49972L9.17352 6.25202ZM9.17352 6.25202L7.6592 5.70136L7.65916 5.70135M9.17352 6.25202L7.65916 5.70135M7.65916 5.70135L7.64623 5.69664C7.55318 5.6628 7.45959 5.62877 7.37688 5.60548C7.28429 5.57942 7.1724 5.5567 7.04429 5.56502L7.04428 5.56502M7.65916 5.70135L7.04428 5.56502M7.04428 5.56502C6.86456 5.5767 6.69184 5.63808 6.5452 5.74199L7.04428 5.56502ZM6.15349 6.23535L6.16053 6.22362C6.21146 6.13868 6.2627 6.05325 6.31228 5.98303C6.36778 5.90442 6.44038 5.81626 6.54517 5.742L6.15349 6.23535ZM6.15349 6.23535L6.15347 6.23539L6.0049 6.48299C5.17532 6.01669 4.48401 5.32485 4.01722 4.49498L4.26466 4.34652C4.26466 4.34652 4.26466 4.34652 4.26466 4.34652C4.26855 4.34419 4.27244 4.34185 4.27633 4.33952C4.36129 4.28856 4.44675 4.2373 4.51699 4.1877C4.5956 4.13219 4.68374 4.05959 4.75798 3.95483L6.15349 6.23535ZM9.9035 9.4168C10.0024 9.21173 10.0011 8.98323 10.0002 8.80999C10.0001 8.7936 10 8.77772 10 8.76239V7.432C10 7.41889 10.0001 7.40532 10.0001 7.39135C10.0008 7.24626 10.0017 7.05748 9.93531 6.88488L9.9035 9.4168Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div id="adCarousel" className="carousel slide mt-4" data-bs-ride="carousel">
              <div className="carousel-inner">

                <div className="carousel-item active">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card">
                        <div className="position-relative">
                          <img src={adimg} className="card-img-top" alt="..." />
                          <span className="ad-badge">Ad</span>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">Samanvay</h5>
                          <p className="card-text">Malviya Nagar</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card">
                        <div className="position-relative">
                          <img src={adimg} className="card-img-top" alt="..." />
                          <span className="ad-badge">Ad</span>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">Trimurty</h5>
                          <p className="card-text">Jagatpura</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="carousel-item">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card">
                        <div className="position-relative">
                          <img src={adimg} className="card-img-top" alt="..." />
                          <span className="ad-badge">Ad</span>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">Aashirwad</h5>
                          <p className="card-text">Vaishali Nagar</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card">
                        <div className="position-relative">
                          <img src={adimg} className="card-img-top" alt="..." />
                          <span className="ad-badge">Ad</span>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">Shubh</h5>
                          <p className="card-text">Mansarovar</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button className="custom-btn custom-btn-prev" type="button" data-bs-target="#adCarousel" data-bs-slide="prev">
                <span>&lt;</span>
              </button><button className="custom-btn custom-btn-next" type="button" data-bs-target="#adCarousel" data-bs-slide="next">
                <span>&gt;</span>
              </button>

            </div>

            <div className='top_project mt-4'>
              <p>Top Projects for Sale in Jagatpura</p>
              <div className="titleunderline">
                <svg width="71" height="7" viewBox="0 0 71 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z" fill="#002842" />
                  <line x1="8.5" y1="6.5" x2="62.5" y2="6.5" stroke="#002842" stroke-linecap="round" />
                </svg>
              </div>
              <div className="custom-carousel">

                <div className="carousel slide" id="customSlider" data-bs-ride="carousel">
                  <div className="carousel-inner">

                    <div className="carousel-item active custom-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="custom-overlay">
                        <h3>The Century Garden</h3>
                        <p>Malviya Nagar</p>
                      </div>
                    </div>

                    <div className="carousel-item custom-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="custom-overlay">
                        <h3>Urban Heights</h3>
                        <p>Jagatpura</p>
                      </div>
                    </div>

                    <div className="carousel-item custom-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="custom-overlay">
                        <h3>Skyline Residences</h3>
                        <p>Vaishali Nagar</p>
                      </div>
                    </div>
                  </div>

                  <button className="custom-btn custom-btn-prev" type="button" data-bs-target="#customSlider" data-bs-slide="prev">
                    <span>&lt;</span>
                  </button>
                  <button className="custom-btn custom-btn-next" type="button" data-bs-target="#customSlider" data-bs-slide="next">
                    <span>&gt;</span>
                  </button>
                </div>
              </div>
            </div>

            <div className='popular_locality mt-4'>
              <p>Popular Locality for sale</p>
              <div className="titleunderline">
                <svg width="71" height="7" viewBox="0 0 71 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z" fill="#002842" />
                  <line x1="8.5" y1="6.5" x2="62.5" y2="6.5" stroke="#002842" stroke-linecap="round" />
                </svg>
              </div>
              <div className='d-flex justify-content-center gap-2'>
                <svg data-bs-target="#uniqueCardSlider" data-bs-slide="prev" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1339_5721)">
                    <path d="M7.5 1.25C4.04812 1.25 1.25 4.04812 1.25 7.5C1.25 10.9519 4.04812 13.75 7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04812 10.9519 1.25 7.5 1.25Z" fill="white" stroke="#A4A4A4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8.2876 5.29355L6.0876 7.4998L8.2876 9.70605" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1339_5721">
                      <rect width="15" height="15" fill="white" transform="matrix(-1 0 0 -1 15 15)" />
                    </clipPath>
                  </defs>
                </svg>

                <svg data-bs-target="#uniqueCardSlider" data-bs-slide="next" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1339_5718)">
                    <path d="M7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04813 10.9519 1.25 7.5 1.25C4.04813 1.25 1.25 4.04813 1.25 7.5C1.25 10.9519 4.04813 13.75 7.5 13.75Z" fill="white" stroke="#A4A4A4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.7124 9.70645L8.9124 7.5002L6.7124 5.29395" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1339_5718">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="custom-slider">
                <div id="uniqueCardSlider" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner custom-carousel-inner">

                    <div className="carousel-item active">
                      <div className="row">
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="carousel-item">
                      <div className="row">
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6 mb-4">
                          <div className="unique-card">
                            <h5>Narsinghpura</h5>
                            <div className='pricing_det'>
                              <p className="price">₹3,814</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className='price_grap'>
                              <p className="price">27.60% ▲ </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <button className='btn view-projects-btn'>
                              View Projects
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='top_resale mt-4 mb-4'>
              <p>Top Resale Projects in Jagatpura</p>
              <div className="titleunderline">
                <svg width="71" height="7" viewBox="0 0 71 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z" fill="#002842" />
                  <line x1="8.5" y1="6.5" x2="62.5" y2="6.5" stroke="#002842" stroke-linecap="round" />
                </svg>
              </div>
              <div className="unique-carousel">

                <div id="uniqueSlider" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">

                    <div className="carousel-item active unique-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="unique-overlay">
                        <h3>Luxury Heights</h3>
                        <p>Malviya Nagar</p>
                      </div>
                    </div>

                    <div className="carousel-item unique-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="unique-overlay">
                        <h3>Skyline Homes</h3>
                        <p>Jagatpura</p>
                      </div>
                    </div>

                    <div className="carousel-item unique-slide">
                      <img src={top3} className="card-img-top" alt="..." />
                      <div className="unique-overlay">
                        <h3>Urban Paradise</h3>
                        <p>Vaishali Nagar</p>
                      </div>
                    </div>
                  </div>

                  <button className="unique-btn unique-btn-prev" type="button" data-bs-target="#uniqueSlider" data-bs-slide="prev">
                    <span>&lt;</span>
                  </button>
                  <button className="unique-btn unique-btn-next" type="button" data-bs-target="#uniqueSlider" data-bs-slide="next">
                    <span>&gt;</span>
                  </button>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>

    </div>

  );
};

export default PropertyList; 